import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    HomeOutlined,
    AttachMoney,
    CheckCircleOutline,
    LocationCity,
    LocalShippingOutlined,
    MeetingRoomOutlined,
    KingBedOutlined,
    ElectricBoltOutlined,
    VerifiedUserOutlined,
    LocalOfferOutlined
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアで初期費用を抑えるポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('cost-breakdown')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    初期費用の内訳を知ろう
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('zero-deposit-rentals')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    敷金・礼金ゼロ物件の特徴と探し方
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('guarantor-company')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    保証会社の選び方
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('furnished-merits')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    家具家電付き物件のメリット
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('moving-tips')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    お得な引っ越し術
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button 
                    variant="outlined" 
                    size="small" 
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアで初期費用を抑えるポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 3 }}>
                    新生活を始める際に「できるだけ初期費用を節約したい」と考える方は多いはず。特にルームシェアは、家賃や光熱費を分担できるだけでなく、初期費用も大きく抑えられる傾向があります。しかし、「敷金・礼金ゼロ」「保証会社不要」「家具家電付き」など、お得なキーワードの裏に隠れた注意点も。この記事では、ルームシェアでの初期費用の内訳から、ゼロ物件の探し方、保証会社選び、家具家電付き物件のメリット、さらにお得に引っ越すコツまで、実践的なノウハウを分かりやすく解説します。
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6}>
                        
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
                            <Typography variant="body2" color="textSecondary">
                                ルームシェアは、初期費用を抑えつつ快適な暮らしを叶える現代的な選択肢です。
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Typography variant="body2" color="textSecondary">
                    ※この記事は、ルームシェアの専門的知見をもとに、実際に役立つ情報のみを厳選してお届けしています。
                </Typography>
            </Box>

            {/* 初期費用の内訳 */}
            <Box id="cost-breakdown" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    初期費用の内訳を知ろう
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    「ルームシェアなら初期費用が安い！」とよく言われますが、実際にかかるコストを正しく理解しておくことが大切です。主な内訳を以下にまとめました。
                </Typography>
                <Paper elevation={0} sx={{ p: 2, bgcolor: '#fafafa', borderLeft: '4px solid #90caf9', mb: 2 }}>
                    <List>
                        <ListItem>
                            <ListItemIcon><AttachMoney color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="敷金"
                                secondary="退去時の原状回復費用に充てられるお金。ルームシェア物件ではゼロ円のケースも多い。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><AttachMoney color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="礼金"
                                secondary="契約時に大家さんへ支払うお礼のお金。最近はゼロ円物件も増加。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><MeetingRoomOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="前家賃・日割り家賃"
                                secondary="契約開始日から月末までの家賃。ルームシェアでは人数で割るため負担が軽い。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><VerifiedUserOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="保証会社利用料"
                                secondary="連帯保証人の代わりに保証会社を利用する際に必要。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><ElectricBoltOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="火災保険"
                                secondary="万が一に備えて必須。費用は1〜2万円程度で1〜2年ごとに更新。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><LocalShippingOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="引っ越し費用"
                                secondary="単身用パックやフリープランを利用すれば、安く抑えることも可能。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><KingBedOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary="家具・家電購入費"
                                secondary="家具家電付き物件ならほぼ不要、ゼロから揃える場合は10万円以上かかることも。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                    ※物件やエリアによっては、仲介手数料や鍵交換費用、クリーニング費用も発生します。契約時に必ず確認を。
                </Typography>
                
            </Box>

            {/* 敷金・礼金ゼロ物件の特徴 */}
            <Box id="zero-deposit-rentals" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    敷金・礼金ゼロ物件の特徴と探し方
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    敷金・礼金ゼロ物件（通称「ゼロゼロ物件」）は、初期費用を大きく抑えたい人にとって強い味方。ルームシェアで選ばれることが多い理由や注意点、探し方を解説します。
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={7}>
                        <Paper elevation={0} sx={{ p: 2, bgcolor: '#f1f8e9', borderLeft: '4px solid #aed581' }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                <CheckCircleOutline color="success" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                ゼロゼロ物件のポイント
                            </Typography>
                            <List dense>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon><LocalOfferOutlined color="success" /></ListItemIcon>
                                    <ListItemText primary="初期費用が大幅ダウン" secondary="まとまった資金なしで新生活を始められる" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon><LocationCity color="success" /></ListItemIcon>
                                    <ListItemText primary="入居審査が比較的ゆるい傾向" secondary="シェアハウスや外国人向け、学生向けに多い" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon><AttachMoney color="success" /></ListItemIcon>
                                    <ListItemText primary="家賃がやや高めに設定されることも" secondary="その分、月々の負担に注意が必要" />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                                    <ListItemText primary="短期契約OK物件も多い" secondary="ワーキングホリデーや一時利用にも便利" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box component="img"
                            src="/images/blog/zero-deposit-room_roomshare-shokihi-zero-method.jpg"
                            alt="敷金・礼金ゼロ円をアピールする募集チラシと、明るい内装のワンルーム。シンプルなインテリアと清潔な空間が、初めてのルームシェアでも安心して入居できる雰囲気を演出。"
                            sx={{ width: '100%', borderRadius: 2, boxShadow: 1 }}
                        />
                    </Grid>
                </Grid>
                <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                    <LocalOfferOutlined sx={{ verticalAlign: 'middle', mr: 1 }} />
                    <b>ゼロゼロ物件の探し方</b>
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon><HomeOutlined color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="不動産検索サイトで『敷金ゼロ・礼金ゼロ』条件を設定"
                            secondary="SUUMO、HOMES、CHINTAIなどの大手サイトや、シェアハウス専門ポータルを活用"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="『保証人不要』や『家具家電付き』もチェック"
                            secondary="初期費用がさらに抑えられる物件が見つかる"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><LocationCity color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="エリアによって物件数に差がある"
                            secondary="都市部や学生街、外国人向け物件に多い傾向"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><AttachMoney color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="条件が良すぎる場合は内容をよく確認"
                            secondary="退去時費用や短期解約違約金が発生することも"
                        />
                    </ListItem>
                </List>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    <b>専門家アドバイス：</b>「ゼロゼロ物件」でも、契約書や入退去時の条件を丁寧に確認することが大切です。特に「クリーニング費用」や「原状回復費用」の規定は要チェック！
                </Typography>
            </Box>

            {/* 保証会社の選び方 */}
            <Box id="guarantor-company" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    保証会社の選び方
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアでは、連帯保証人の代わりに保証会社を利用するケースが一般的です。どんな基準で選べばよいか、失敗しないポイントをまとめました。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ mb: 1 }}>
                                    <VerifiedUserOutlined color="primary" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                    保証会社選びのポイント
                                </Typography>
                                <List dense>
                                    <ListItem sx={{ py: 0.5 }}>
                                        <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                        <ListItemText primary="信頼できる大手を選ぶ" secondary="実績と評判を確認" />
                                    </ListItem>
                                    <ListItem sx={{ py: 0.5 }}>
                                        <ListItemIcon><AttachMoney color="primary" /></ListItemIcon>
                                        <ListItemText primary="初期費用・年間費用の比較" secondary="初回保証料は家賃の30～50%が目安" />
                                    </ListItem>
                                    <ListItem sx={{ py: 0.5 }}>
                                        <ListItemIcon><KingBedOutlined color="primary" /></ListItemIcon>
                                        <ListItemText primary="ルームシェア対応か要確認" secondary="全員が契約対象か、代表者のみかも確認" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={{ p: 2, bgcolor: '#fffde7', borderLeft: '4px solid #ffe082', height: '100%' }}>
                            <Typography variant="body2" color="textSecondary">
                                <b>チェックポイント：</b>保証会社によっては、在留カードや学生証のみで審査可能なところも。<br />
                                逆に、収入証明や日本語力を重視する会社もあるので、自分に合った会社を選びましょう。
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                    <b>POINT:</b> 保証会社の審査に不安がある場合は、ルームシェア専門の仲介会社に相談するのも有効です。
                </Typography>
            </Box>

            {/* 家具家電付き物件のメリット */}
            <Box id="furnished-merits" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    家具家電付き物件のメリット
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアで人気なのが「家具家電付き」物件。初期費用・手間・時間のすべてを節約できる、現代の新生活にぴったりの賢い選択です。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={7}>
                        <List>
                            <ListItem>
                                <ListItemIcon><KingBedOutlined color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary="ベッド・デスク・チェア完備"
                                    secondary="引っ越し初日からすぐ生活を始められる"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><ElectricBoltOutlined color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary="冷蔵庫・洗濯機・レンジ付き"
                                    secondary="大型家電の購入＆搬入が不要"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><HomeOutlined color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary="カーテン・照明も標準装備"
                                    secondary="細かな出費や手配の手間がかからない"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><LocalShippingOutlined color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary="引っ越し費用も節約"
                                    secondary="大きな家具家電がない分、単身パックで安く済む"
                                />
                            </ListItem>
                        </List>
                        <Box sx={{ mt: 2 }}>
                            <Chip label="身軽に新生活スタート" color="primary" variant="outlined" sx={{ mr: 1 }} />
                            <Chip label="初期費用ダウン" color="primary" variant="outlined" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box component="img"
                            src="/images/blog/furnished-room_roomshare-shokihi-zero-method.jpg"
                            alt="家具家電が揃ったルームシェア個室の写真。シンプルなベッドとデスク、明るい窓、コンパクトな収納棚が配置され、入居者がすぐに生活を始められる環境が整っている。"
                            sx={{ width: '100%', borderRadius: 2, boxShadow: 1 }}
                        />
                    </Grid>
                </Grid>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                    <b>注意：</b> 共用部の設備（キッチン家電や掃除機など）は全員で使うもの。使い方ルールや備品の充実度を契約前に確認しておくと安心です。
                </Typography>
            </Box>

            {/* お得な引っ越し術 */}
            <Box id="moving-tips" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    お得な引っ越し術
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアの引っ越しは、工夫次第でさらにお得＆スムーズに。専門家の視点から、知っていると差がつくコツを解説します。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={0} sx={{ p: 2, bgcolor: '#e8eaf6', borderLeft: '4px solid #7986cb' }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                <LocalShippingOutlined color="primary" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                ルームシェアならではの引っ越し術
                            </Typography>
                            <List dense>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="荷物は最小限に！"
                                        secondary="家具家電付き物件ならキャリーバッグひとつでもOK"
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon><LocalShippingOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="単身パックや宅配便を活用"
                                        secondary="大手引っ越し業者の単身向けプランを比較"
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon><ElectricBoltOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="フリマアプリで不用品処分"
                                        secondary="リサイクルで小遣い稼ぎ＆荷物も減らせる"
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon><LocationCity color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="平日・シーズンオフを狙う"
                                        secondary="引っ越し代が大幅割引になることも"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box component="img"
                            src="/images/blog/moving-tips_roomshare-shokihi-zero-method.jpg"
                            alt="キャリーバッグと段ボールを持って新居に到着する若い女性。明るいエントランスと、荷物の少なさからルームシェアの身軽な引っ越しスタイルが伝わる。"
                            sx={{ width: '100%', borderRadius: 2, boxShadow: 1 }}
                        />
                    </Grid>
                </Grid>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        <ElectricBoltOutlined color="primary" sx={{ verticalAlign: 'middle', mr: 1 }} />
                        <b>まとめ：初期費用を抑えつつ理想のルームシェアを</b>
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        ルームシェアは、初期費用を大幅にカットできる上に、生活コストの分担やコミュニティ形成など多くのメリットがあります。敷金・礼金ゼロ物件や家具家電付き物件、保証会社の選び方など、ポイントを押さえて理想の新生活をスタートさせましょう！
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        <Chip icon={<AttachMoney />} label="敷金ゼロ" color="primary" variant="outlined" />
                        <Chip icon={<AttachMoney />} label="礼金ゼロ" color="primary" variant="outlined" />
                        <Chip icon={<VerifiedUserOutlined />} label="保証会社" color="primary" variant="outlined" />
                        <Chip icon={<KingBedOutlined />} label="家具家電付き" color="primary" variant="outlined" />
                        <Chip icon={<LocalShippingOutlined />} label="引っ越し術" color="primary" variant="outlined" />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-shokihi-zero-method',
    slug: 'roomshare-shokihi-zero-method',
    title: 'ルームシェアで初期費用を抑える方法！敷金・礼金ゼロ物件の探し方',
    excerpt: '初期費用の内訳や敷金・礼金ゼロ物件の特徴、保証会社の選び方、家具家電付き物件のメリット、お得な引っ越し術まで、ルームシェアで初期費用を抑える実践的な方法を徹底解説！',
    coverImage: '/images/blog/cover-share-house-living_roomshare-shokihi-zero-method.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。カラフルなインテリアと観葉植物が温かい雰囲気を演出し、新生活のワクワク感が伝わる一枚。',
    publishedAt: '2024-06-16T00:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '初期費用', '引っ越し'],
    tags: ['敷金ゼロ', '礼金ゼロ', '家具家電付き', '保証会社', '引っ越し術'],
    author: {
        name: '山田 明',
        avatar: '/images/avatars/akira-yamada.jpg',
        bio: 'ルームシェア歴10年、物件紹介や住み替えアドバイスに精通。シェアハウス専門のコーディネーターとして、200件以上のマッチング経験を持つ。',
        profilePicture: '/images/avatars/akira-yamada.jpg'
    },
    viewCount: 1570,
    contentComponent: PostContent
};

export default post;